import { createContext } from "react";
import { Remove2faContextType } from "./types";

export const Remove2faContext = createContext<Remove2faContextType | undefined>(
  undefined
);
